// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const EraserOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M20.12 12.33a2.5 2.5 0 000-3.55l-4.1-4.1a2.57 2.57 0 00-3.56-.01l-8.58 8.57c-.48.47-.74 1.1-.74 1.79 0 .68.26 1.31.74 1.77l1.56 1.57H4.18a.84.84 0 000 1.67h15.07a.84.84 0 000-1.67h-5.17l6.04-6.04zm-6.47-6.49a.8.8 0 01.58-.24c.16 0 .4.04.6.25l4.1 4.11a.83.83 0 010 1.19l-2.5 2.51-5.3-5.3 2.52-2.52z","fill":"currentColor"}}]},"name":"eraser","theme":"outlined"};

const EraserOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={EraserOutlinedSvg} />;
  EraserOutlined.displayName = 'EraserOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(EraserOutlined);
